export const clearFields = (form) => {

    if (form?.projekt_status_spr !== 'rezygnacja' && form?.projekt_status_spr !== 'nie_podlega') {
        delete form?.uzasadnienie
    }

    if (form?.czy_komitet !== 'Tak') {
        delete form?.data_posiedzenia_ks
    }

    return form
}

export const clearKontakt = (form) => {
    const newForm = { ...form }
    if (newForm?.kontakt_z_kp !== 'Nie') {
        delete newForm.kontakt_list
    }
    return newForm
}

export const clearRyzyka = (form) => {
    const newForm = { ...form }

    if (Array.isArray(newForm?.ryzyka_list)) {
        newForm.ryzyka_list = newForm.ryzyka_list.map((ryzyko) => {
            if (ryzyko?.status !== 'Wystąpiło') {
                const { termin_dzialan_zapobiegawczych, przyczyna, ...rest } = ryzyko
                return rest
            }
            return ryzyko
        })
    }

    return newForm
}

export class CLEAR_S {
    dane(form) {
        form = clearFields(form)
        return form
    }
    ryzyka(form) {
        form = clearRyzyka(form)
        return form
    }
    kontakt(form) {
        form = clearKontakt(form)
        return form
    }
}
